import React from "react";
import { Button } from "primereact/button";
import Bagno from "./Bagno";
import { Accordion, AccordionTab } from "primereact/accordion";

const Bagni = (props) => {
  
  const handleAggiungiBagno = () => {
    const bagniAggiornato = [...props.preventivo.bagni];
    bagniAggiornato.push(null);
    props.onChange(bagniAggiornato);
  }

  const handleRimuoviBagno = (indice) => {
    const app = [...props.preventivo.bagni];
    app.splice(indice, 1);
    props.onChange(app);
    //setBagni(bagni)
  }

  const handleAggiornabagno = (bagno, indice) => {
    props.preventivo.bagni[indice] = bagno;

    props.onChange(props.preventivo.bagni);
  }

  //console.log("props.preventivo.bagni", props.preventivo.bagni);
  const renderBagno = (indice, singolo) => {
    
    return (
      <>
        {
          <Bagno
            preventivo={props.preventivo}
            indice={indice}
            singolo = {singolo}
            handleRimuoviBagno={(keyr) => handleRimuoviBagno(keyr)}
            onChange={(bagno, keyc) => handleAggiornabagno(bagno, keyc)}
          />
        }
      </>
    );
  };

  return (
    <>
      <div className="surface-ground px-1 py-1 md:px-4 md:py-4">
        <div className="text-900 font-medium text-900 text-xl mb-2"></div>
        <p className="m-0 mb-2 p-0 text-600 line-height-3 mr-3">
          {/* Nota: sono compresi materiali necessari per l'edificazione della
              struttura, escludendo qualsiasi decoro aggiuntivo specificatamente
              richiesto dal committente*/}
              
        </p>
        {
          props?.preventivo?.bagni?.length > 1 ? (
          <Accordion activeIndex={props.preventivo?.bagni.length - 1}>
            {props.preventivo.bagni.map((elem, indice) => (
              <AccordionTab header={"Bagno " + (indice + 1)} key={indice}>
                {renderBagno(indice, false)}
              </AccordionTab>
            ))}
          </Accordion>
        ) : (
          <div className="surface-card p-4 shadow-2 border-round">
            {renderBagno(0, true) }
          </div>
        )}

        <Button
          type="button"
          label="Aggiungi bagno"
          className="px-5 py-3 mt-5 w-auto"
          onClick={() => handleAggiungiBagno()}
        />
      </div>
    </>
  );
};
export default Bagni;
